import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translation } from '../../../../utils/helpers'

// Elements
import Switch from '../../../../shared/elements/switch'
import TextArea from '../../../../shared/elements/textarea'
import DropDown from '../../../../shared/elements/dropDown'
import Icon from '../../../../shared/elements/icon'
import RemoveButton from '../../../../shared/elements/removeButton'
import { ProductionStatus } from '../../../../shared/elements/icons'

class CarOwnerNotificationSettings extends Component {
  constructor (props) {
    super(props)

    this.state = {
      // This should probably be in the backend
      notificationEventType: {
        159: { translationKey: 18167, icon: ProductionStatus.Step_New },
        160: { translationKey: 18168, icon: ProductionStatus.Step_New },
        161: { translationKey: 18169, icon: ProductionStatus.Step_BodyShopDisassemply },
        162: { translationKey: 18170, icon: ProductionStatus.Step_BodyShopDisassemply },
        163: { translationKey: 18171, icon: ProductionStatus.Step_BodyShopRepair },
        164: { translationKey: 18172, icon: ProductionStatus.Step_BodyShopRepair },
        165: { translationKey: 18173, icon: ProductionStatus.Step_Painting },
        166: { translationKey: 18174, icon: ProductionStatus.Step_BodyShopAssembly },
        167: { translationKey: 18175, icon: ProductionStatus.Step_BodyShopAssembly },
        168: { translationKey: 18176, icon: ProductionStatus.Step_Preparing },
        169: { translationKey: 18177, icon: ProductionStatus.Step_Preparing },
        170: { translationKey: 18178, icon: ProductionStatus.Step_Handover },
        171: { translationKey: 18179, icon: ProductionStatus.Step_Handover },
        172: { translationKey: 18187, icon: ProductionStatus.Step_Archived },  // Not implemented yet
        173: { translationKey: 18180, icon: ProductionStatus.Step_Finished },
        174: { translationKey: 18181, icon: ProductionStatus.Step_Finished },
        176: { translationKey: 14827, icon: ProductionStatus.Step_Expected }
      }
    }
  }

  eventTypesList (val, text) {
    return (
      <option key={val} value={val}>{text}</option>
    )
  }

  deriveVariables (setting) {
    const type = Number(setting.Type)
    const offsetDaysArray = Array.from(Array(61).keys())
    const canOffsetBefore = type === 171 || type === 176
    const canOffsetAfter = type === 176 || type === 172
    const offsettableType = canOffsetBefore || canOffsetAfter

    const beforeAfter = setting.Offset < 0 ? 'before' : 'after'
    const days = Math.abs(setting.Offset / 24)
    return { type, offsettableType, days, offsetDaysArray, beforeAfter, canOffsetBefore, canOffsetAfter }
  }

  render () {
    const selectableTypes = Object.entries(this.state.notificationEventType).filter(x => x[0] !== '172')  // TODO: implement this option fully in backend before reactivation
    console.log('types', selectableTypes)

    function renderOption (number) {
      let translationKey = 503

      if (number === 1) translationKey = 483
      return <option key={number} value={number}>{number + ' ' + translation(translationKey)}</option>
    }

    return (
      <span>
        {this.props.data.map((setting, index) => {
          const { type, offsettableType, days, offsetDaysArray, beforeAfter, canOffsetBefore, canOffsetAfter } = this.deriveVariables(setting)

          let onChange = (e) => this.props.onChange(e, setting.Id)
          let onBlur = (e) => this.props.onBlur(e, setting.Id)

          return (
            <div key={index} className='submit-text'>
              <div className='flex'>
                <div className='left'>
                  <Icon size='s' icon={this.state.notificationEventType[setting.Type].icon} />
                  <DropDown name='NotificationType' onChange={onChange} disabled={false} size='m' value={type}>
                    {selectableTypes.map(val => this.eventTypesList(Number(val[0]), translation(val[1].translationKey)))}
                  </DropDown>
                  {offsettableType && (
                    <DropDown name='Days' onChange={onChange} disabled={false} size='m' value={days}>
                      {offsetDaysArray.map(renderOption)}
                    </DropDown>
                  )}
                  {offsettableType && (
                    <DropDown name='BeforeAfter' onChange={onChange} disabled={false} size='m' value={beforeAfter}>
                      {canOffsetBefore && <option key={1} value='before'>{translation(19000)}</option>}
                      {canOffsetAfter && <option key={2} value='after'>{translation(19001)}</option>}
                    </DropDown>
                  )}
                  <RemoveButton spacing={0} onClick={(e) => this.props.deleteNotification(e, setting)} size='m' />
                </div>
                <div className='right'>
                  <Switch name='SMSAllowed' onChange={onChange} checked={setting.SMSAllowed} labelText={15} labelAlignment={'l'} />
                  <Switch name='EmailAllowed' onChange={onChange} checked={setting.EmailAllowed} labelText={1052} labelAlignment={'l'} />
                </div>
              </div>
              <TextArea placeholder={translation(18153)} name='text'
                value={setting.Text}
                onChange={onChange} onBlur={onBlur} />

              {setting.SMSAllowed && <div className='txt-count'>{this.props.countText(setting.Text)}</div>}
            </div>
          )
        })}
      </span>

    )
  }
}

export default connect(null)(CarOwnerNotificationSettings)



// WEBPACK FOOTER //
// ./src/app/pages/Settings/CarOwnerNotification/Settings/index.js